module.exports = __webpack_public_path__ + "static/media/shopify15.1ca029be.png";